import React, { useEffect } from 'react';
import axios from "axios";
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';
import StackTrace from 'stacktrace-js';
var client = axios.create({
    baseURL: SERVICE_URL + "/api/"
});
var hiddenSiteIDInput = document.getElementById('hdnSiteID');
var siteID = hiddenSiteIDInput && hiddenSiteIDInput.value;
export default function NotFoundPage(props) {
    var isFlyoverSite = props.isFlyoverSite;
    var error = useRouteError();
    var errorCallback = function (stackframes) {
        var stringifiedStack = stackframes.map(function (sf) {
            return sf.toString();
        }).join('\n');
        console.log("stringifiedStack: ", stringifiedStack);
        return stringifiedStack;
    };
    var logError = function (error) {
        if (!error)
            return;
        StackTrace.fromError(error)
            .then(errorCallback)
            .then(function (stack) {
            var errorDetails = {
                url: location && location.pathname,
                message: getErrorMessage(error) || 'Unknown error',
                stack: (typeof stack === 'string' || stack instanceof String) && stack || error.stack || 'No stack trace available',
                // Add any additional details you need
            };
            client.post("clienterrorlog?siteID=".concat(siteID), errorDetails);
        })
            .catch(function (e) {
            console.log("error callback: ", e);
        });
    };
    var getErrorMessage = function (error) {
        if (isRouteErrorResponse(error)) {
            return "".concat(error.status, " ").concat(error.statusText);
        }
        else if (error instanceof Error) {
            return error.message;
        }
        else if (typeof error === 'string') {
            return error;
        }
        else {
            console.error(error);
            return 'Unknown error';
        }
    };
    useEffect(function () {
        console.log("Error catched: ", error);
        try {
            logError(error);
        }
        catch (e) {
            console.log(e);
        }
    }, [error]);
    return (React.createElement("div", { className: "container-fluid bg-transparent" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col col-auto" },
                React.createElement(Link, { to: "/" },
                    React.createElement("img", { src: isFlyoverSite ? "/images/logo-flyover.png" : "/images/logo-skylagoon-moss.svg", alt: isFlyoverSite ? "Flyover Logo" : "Skylagoon Logo", width: "187", height: "54", className: "header-logo" })))),
        React.createElement("div", { className: "row justify-content-center" }, "An error has occurred.")));
}
